let domain = process.env.REACT_APP_API_LIVE;
console.log("domain", domain);

const userEndPoints = {

  getWallet: domain + "/my-wallet",
  getOrders: domain + "/affiliate/my-ref-orders",
  couponValidity: domain + "/coupon-validity/",
  addBank: domain + "/add-bank",
  requestPayout: domain + "/request-payout",
  payoutTransactions: domain + "/affiliate/my-payout-transactions",
  allReels: domain + "/all-reels",
  getSubHeader: domain + "/get-subheader-text",
  getBanners: domain + "/promotional-banner",
  getAllCoupons: domain + "/get-checkout-coupons"


};


export { userEndPoints };
